<template>
  <div class="confirm-content-block">
    <div class="confirm">
      <b-row>
        <b-col md="7" offset-md="3">
          <b-alert
            show
            class="mb-5 text-center"
            v-if="confirm.bookingVoucher && confirm.bookingVoucher.status === 'booked' && confirm.doubleCheck.checked"
            :variant="confirm.doubleCheck.variant"
          >
            {{ confirm.doubleCheck.text }}
          </b-alert>
          <b-alert
            show
            class="mb-5 text-center"
            v-else-if="confirm.bookingVoucher && confirm.bookingVoucher.status === 'cancelled'"
            :variant="'danger'"
          >
            Questa prenotazione è stata cancellata e pertanto non più valida.
          </b-alert>
        </b-col>
        <template v-for="(block,key) in confirm_blocks">
          <component
            v-if="block.show"
            v-bind:key="_uid+block+key"
            :is="block.key"
            :confirm="confirm"
          />
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
import ThankYou from '@bookingv3/components/blocks/confirm/thankyou'
import Support from '@bookingv3/components/blocks/confirm/support'
import CodesReferences from '@bookingv3/components/blocks/confirm/codes-references'
import Reservation from '@bookingv3/components/blocks/confirm/reservation'
import Hotel from '@bookingv3/components/blocks/confirm/hotel'
import CancellationPolicy from '@bookingv3/components/blocks/confirm/cancellation-policy'
import Services from '@bookingv3/components/blocks/confirm/services'
import Info from '@bookingv3/components/blocks/confirm/info'
import Conditions from '@bookingv3/components/blocks/confirm/conditions'

export default {
  name: 'confirm-content-block',

  components: {
    'thankyou': ThankYou,
    'support': Support,
    'codes-references': CodesReferences,
    'reservation': Reservation,
    'hotel': Hotel,
    'cancellation-policy': CancellationPolicy,
    'services': Services,
    'info': Info,
    'conditions': Conditions,
  },

  props: {
    confirm: Object, 
  },

  data() {
    return {
      confirm_blocks: [],
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    this.confirm_blocks = [
      {
        key: "thankyou",
        show: true,
      },
      {
        key: "support",
        show: true,
      },
      {
        key: "codes-references",
        show: true,
      },
      {
        key: "reservation",
        show: true,
      },
      {
        key: "hotel",
        show: true,
      },
      {
        key: "cancellation-policy",
        show: true,
      },
      {
        key: "services",
        show: true,
      },
      {
        key: "info",
        show: true,
      },
      {
        key: "conditions",
        show: true,
      },
    ]
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>